// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@sc/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        display: flex;
        height: 50px;
        width: 273px;
        ${xScreen("lte", "md")} {
            height: 30px;
            width: 163px;
        }
    `,
};

logoStyles.img = {
    css: css`
        width: 100%;
        height: auto;
        max-height: 100%;
        max-width: 100%;
        && img {
            width: 100%;
            height: auto;
        }
    `,
};

logoStyles.hiddenStyle = {
    css: css`
        display: flex;
    `,
};
